<template>
  <v-dialog
    v-model="isVisible"
    width="600"
    @click:outside="onHandleConfirm"
    @keydown.esc="onHandleConfirm"
  >
    <v-card>
      <v-toolbar color="blue-grey-darken-2">
        <v-card-title class="text-h5 text-center">{{ $t("ImportResultDialog.Dialog.ImportResult.Headline") }}</v-card-title>
      </v-toolbar>
      <v-card-text class="pt-5">
        <div class="ml-1">
          <v-chip
            class="ma-2"
            color="green"
            label
            text-color="white"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            {{
              $t("ImportResultDialog.Dialog.ImportResult.SuccessfulImports", {successfulImports: props.importResult.successfulImports})
            }}
          </v-chip>
        </div>
        <div class="ml-1">
          <v-chip
            class="ma-2"
            color="red"
            label
            text-color="white"
          >
            <v-icon left>
              mdi-close
            </v-icon>
            {{ $t("ImportResultDialog.Dialog.ImportResult.RejectedImports", {failedImports: props.importResult.failedImports}) }}
          </v-chip>
        </div>
        <div class="ml-3 mt-2">
          <v-btn
            v-if="hasIncorrectLinesCsv"
            class="import-result-download-link px-1"
            color="primary"
            data-test="download-incorrect-lines"
            prepend-icon="mdi-download"
            variant="text"
            @click="onHandleDownload"
          >
            {{ $t("ImportResultDialog.Dialog.ImportResult.Link") }}
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions class="justify-center">
        <BaseButton
          :buttonText="$t('ImportResultDialog.Dialog.Buttons.Confirm')"
          :isDisabled="false"
          @click="onHandleConfirm"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import {
  computed,
  ref,
} from "vue";
import type { PropType } from "vue";

import BaseButton from "@/components/buttons/BaseButton.vue";

import {
  FileDownload,
} from "@/scripts/Common/FileDownload";

import {
  useI18n,
} from "@/composables/useI18n";

import type {
  ImportResult
} from "@/scripts/Common";

const {
  t,
} = useI18n();

const props = defineProps({
  importResult: {
    required: true,
    type: Object as PropType<ImportResult>,
  },
  csvFileName: {
    type: String,
    default: null
  }
});

const isVisible = ref<boolean>(false);

const hasIncorrectLinesCsv = computed(() => !!props.importResult.incorrectLinesAsCsv);

const show = () => {
  isVisible.value = true;
};

const hide = () => {
  isVisible.value = false;
};

const onHandleConfirm = () => {
  hide();
};

const onHandleDownload = () => {
  if (!!props.importResult.failedImports && props.importResult.failedImports > 0) {
    const fileName = props.csvFileName || t("ImportResultDialog.CsvFileName").toString();
    FileDownload.Create(props.importResult.incorrectLinesAsCsv, fileName);
  }
};

defineExpose({
  show,
})

</script>

<style scoped>
.import-result-download-link {
  cursor: pointer;
  text-transform: none;
}
</style>
